<template>
  <div>
    <!-- Заголовок и кнопка -->
    <div class="children-header">
      <v-btn
        class="add-child-btn"
        outlined
        :loading="isOpening"
        @click="openModalWindowAddChild"
      >
        <v-icon left>mdi-plus</v-icon>
        {{ $t('profile.addChild') }}
      </v-btn>
    </div>

    <!-- Список детей -->
    <v-row>
      <v-col
        v-for="(student, index) in children"
        :key="index"
        cols="12"
        xs="12"
        sm="6"
        md="4"
        lg="3"
      >
        <ScheduleCard :student="student" />
      </v-col>
      
      <!-- Пустое состояние -->
      <v-col
        v-if="!isLoading && (!children || children.length === 0)"
        cols="6"
        class="empty-state"
      >
        <div class="empty-state-content">
          <v-icon size="64" class="no-children-icon">mdi-account-child</v-icon>
          <h3 class="empty-state-title">{{ $t('profile.noChildren') }}</h3>
          <p class="empty-state-text">{{ $t('profile.noChildrenDescription') }}</p>
        </div>
      </v-col>
    </v-row>
    
    <!-- Индикатор загрузки -->
    <div v-if="isLoading" class="loading-container">
      <ProgressCircular />
    </div>

    <!-- Модальное окно добавления ребенка -->
    <v-dialog 
      v-model="showModalWindowAddChild" 
      max-width="500"
      content-class="custom-dialog"
    >
      <v-card class="dialog-card">
        <!-- Хидер -->
        <div class="dialog-header">
          <h3 class="dialog-title">Балалар</h3>
        </div>
        
        <!-- Контент -->
        <div class="dialog-content">
          <p class="dialog-text">
            Сіздің Мобильдік азаматтар базасында (МАБ) тіркелген нөміріңізге,
            SMS (СМС) жіберілді. Балаларды қосу үшін,
            сол хабарламаға «Иә» деген жауапты білдіретін код түрінде SMS жауап қайтарыңыз
            және төмендегі бастырманы басыңыз.
          </p>
          
          <!-- Кнопка "Жауап бердім" -->
          <div class="action-buttons">
            <v-btn
              class="confirm-btn"
              color="#5e5af9"
              dark
              rounded
              large
              :loading="isAdding"
              @click="handleConfirm"
            >
              Жауап бердім
            </v-btn>
            
            <!-- Кнопка "Жабу" -->
            <v-btn
              class="close-btn"
              outlined
              v-if="!isAdding"
              @click="showModalWindowAddChild = false"
            >
              Жабу
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ScheduleCard from "@/views/profile/ScheduleCard.vue";
import { mapActions, mapGetters } from "vuex";
import ProgressCircular from "@/components/custom/ProgressCircular.vue";
import { showToast } from "@/utils/toast";

export default {
  name: "Children",
  components: { ProgressCircular, ScheduleCard },
  data() {
    return {
      isLoading: false,
      isAdding: false,
      isOpening: false,
      showModalWindowAddChild: false,
    };
  },
  created() {
    this.initializePageData();
  },
  methods: {
    ...mapActions({
      fetchChildren: "children/loadChildren",
      exportChild: "exportChild/loadExportChild",
    }),
    async initializePageData() {
      if (this.isLoading) return;

      this.isLoading = true;
      try {
        await this.fetchChildren();
      } catch (error) {
        showToast(this, {
          text: `${error.response.data.message || error}`,
          status: "error",
          duration: 3000,
        });
      } finally {
        this.isLoading = false;
      }
    },
    
    async openModalWindowAddChild() {
      this.isOpening = true;
      try {
        await this.exportChild();
      } catch (error) {
        showToast(this, {
          text: `${error.response.data.message || error}`,
          status: "error",
          duration: 3000,
        });
      } finally {
        this.isOpening = false;
        this.showModalWindowAddChild = true;
      }
    },
    
    async handleConfirm() {
      this.isAdding = true;
      try {
        const responce = await this.exportChild();
        if (responce && responce.status == 1) {
          showToast(this, {
            text: this.$t('toastText.smsNotAnswered'),
            status: "warning",
            duration: 3000,
          });
          this.isAdding = false;
        }else if (responce && responce.status == 2) {
          showToast(this, {
            text: this.$t('toastText.childAddedSuccess'),
            status: "success",
            duration: 3000,
          });
          this.isAdding = false;
          this.showModalWindowAddChild = false;
          await this.fetchChildren();
        }else if (responce && responce.status == 3) {
          showToast(this, {
            text: this.$t('toastText.noChildrenFound'),
            status: "error",
            duration: 3000,
          });
          this.isAdding = false;
          this.showModalWindowAddChild = false;
        }else if (responce && responce.status == 0) {
          showToast(this, {
            text: this.$t('toastText.smsAnsweredNoCorrectly'),
            status: "error",
            duration: 3000,
          });
          this.isAdding = false;
          this.showModalWindowAddChild = false;
        }else{
          showToast(this, {
            text: this.$t('toastText.serverError'),
            status: "error",
            duration: 3000,
          });
          this.isAdding = false;
          this.showModalWindowAddChild = false;
        }
      } catch (error) {
        showToast(this, {
          text: `${error.response.data.message || error}`,
          status: "error",
          duration: 3000,
        });
      }
    }
  },
  computed: {
    ...mapGetters("children", ["children"]),
  },
};
</script>

<style scoped>
.children-header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 24px;
  padding: 0 16px;
}

.add-child-btn {
  text-transform: none;
  border-radius: 8px;
  padding: 8px 20px;
  font-weight: 500;
  min-width: 200px;
  color: #5e5af9;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}

.no-children-icon{
  color: #5e5af9;
}

.row {
  width: 100%;
  margin: 0 !important;
}

.empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 50px auto;
}

.empty-state-content {
  text-align: center;
  padding: 40px 20px;
}

.empty-state-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin: 16px 0 8px;
}

.empty-state-text {
  font-size: 16px;
  color: #666;
  margin-bottom: 24px;
  line-height: 1.5;
}

/* Стили для модального окна */
.custom-dialog {
  border-radius: 24px !important;
}

.dialog-card {
  border-radius: 24px !important;
  overflow: hidden;
}

.dialog-header {
  padding-top: 40px;
}

.dialog-title {
  font-size: 20px;
  font-weight: 700;
  margin: 0;
  text-align: center;
}

.dialog-content {
  padding-bottom: 40px;
  padding-left: 35px;
  padding-right: 35px;
  padding-top: 20px;
}

.dialog-text {
  font-size: 16px;
  line-height: 1.5;
  color: #555;
  margin-bottom: 20px;
  text-align: center;
}

.action-buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  margin-top: 20px;
}

.confirm-btn {
  background-color: #5e5af9 !important;
  color: white !important;
  font-weight: 500;
  padding: 0 32px !important;
  min-width: 200px;
  text-transform: none;
  box-shadow: 0 4px 12px rgba(94, 90, 249, 0.25);
}

.confirm-btn:hover {
  background-color: #4d49f7 !important;
  box-shadow: 0 6px 16px rgba(94, 90, 249, 0.3);
}

.close-btn {
  border-color: #ddd !important;
  color: #666 !important;
  font-weight: 500;
  padding: 0 32px !important;
  min-width: 200px;
  text-transform: none;
}

.close-btn:hover {
  border-color: #5e5af9 !important;
  color: #5e5af9 !important;
  background-color: rgba(94, 90, 249, 0.05);
}

/* Адаптивность */
@media (max-width: 768px) {
  .children-header {
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }
  
  .children-title {
    font-size: 20px;
  }
  
  .add-child-btn {
    width: 50%;
  }
  
  .empty-state-content {
    padding: 20px 0;
  }
  
  .empty-state-title {
    font-size: 18px;
  }
  
  .empty-state-text {
    font-size: 14px;
  }
  
  .dialog-content {
    padding: 20px 16px;
  }
  
  .dialog-text {
    font-size: 15px;
  }
  
  .confirm-btn,
  .close-btn {
    min-width: 180px;
    padding: 0 24px !important;
  }
}

@media (max-width: 480px) {
  .children-header {
    padding: 0;
  }
  
  .empty-state {
    min-height: 250px;
  }
  
  .custom-dialog {
    margin: 16px;
  }
  
  .dialog-header {
    padding: 20px 16px 16px;
  }
  
  .dialog-title {
    font-size: 18px;
  }
  
  .dialog-text {
    font-size: 14px;
    margin-bottom: 24px;
  }
  
  .confirm-btn,
  .close-btn {
    min-width: 160px;
    padding: 0 20px !important;
    font-size: 14px;
  }
}
</style>